/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/

import { IConsolidatedOrder } from '@src/oms/utils/RmFulfillmentUtils';
import { getConsolidatedOrderEndpoint } from '@src/oms/InvoicesView/utils/InvoicesOperationUtils';
import { useCallback, useState } from 'react';
import { request } from '@broadleaf/admin-components/dist/metadata/utils/request';

type Response = {
  fetchConsolidatedOrder: (
    orderId: string,
    contextParams: any
  ) => Promise<IConsolidatedOrder>;
  isLoading: boolean;
};

export default function useFetchConsolidatedOrder(): Response {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchConsolidatedOrder = useCallback(
    async (orderId, contextParams) => {
      if (isLoading) {
        return;
      }

      setIsLoading(true);
      try {
        const req = {};
        const endpoint = getConsolidatedOrderEndpoint(orderId);
        const { data } = await request(
          { method: 'get', data: req, ...endpoint },
          contextParams
        );
        return data;
      } finally {
        setIsLoading(false);
      }
    },
    [isLoading]
  );

  return { fetchConsolidatedOrder, isLoading };
}
